import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Calendar } from 'primeng/calendar';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-calendar-with-timezone',
  templateUrl: './calendar-with-timezone.component.html',
  styleUrls: ['./calendar-with-timezone.component.scss']
})
export class CalendarWithTimezoneComponent implements OnInit {
  @ViewChild('calendar') calendar: Calendar;
  @Input() defaultDate: Date;
  @Input() disabled: boolean = false;
  @Input() showTime: any;
  @Input() hourFormat: any;
  @Input() displayTimeZone:boolean = false;
  @Output() dateSelected = new EventEmitter<any>();
  @Input() parentWidth:string='';
  selectedDate: Date;
  selectedTimezone: string;
  timezones: any[] = [];
  selectedDateWithTimeZone: string;
  dateFormatter=/^(0[1-9]|1[0-2])\/([0-2][0-9]|3[01])\/(\d{4})\s(0[1-9]|1[0-2]):([0-5][0-9])\s(AM|PM)\s\+([0-1][0-9]):([0-5][0-9])$/;
  constructor() { }

  ngOnInit() {
    this.initializeTimezones();
    this.setTimeZoneValue();
  }

  private initializeTimezones() {
    this.timezones = moment.tz.names().map(tz => {
      const offset = moment.tz(tz).format('Z');
      return {
        label: `${tz} ${offset}`,
        value: offset,
        zoneName: tz
      };
    }).sort((a, b) => a.value.localeCompare(b.value));

    // Set default timezone
    const userTimezone = moment.tz.guess();
    this.selectedTimezone = moment.tz(userTimezone).format('Z');
  }

  formatDateWithTimezone(date: Date): string {
    if (!date) return '';
    
    try {
      const formattedDate = moment(date).format('MM/DD/YYYY hh:mm A');
      const timezone = this.selectedTimezone || moment().format('Z');
      if(this.displayTimeZone){
        return `${formattedDate} ${timezone}`;
      }else{
        return `${formattedDate}`;
      }
    } catch (error) {
      console.error('Date formatting error:', error);
      return '';
    }
  }

  onDateTimeSelect(event: any) {
    try {
      this.selectedDate = event;
      this.selectedDateWithTimeZone = this.formatDateWithTimezone(event);
      this.dateSelected.emit({
        date: this.selectedDateWithTimeZone,
        timezone: this.selectedTimezone,
        formattedDate: this.selectedDateWithTimeZone
      });
    } catch (error) {
      console.error('Date selection error:', error);
    }
  }

  onTimezoneChange(event: any) {
    if (!event?.value) return;
    this.selectedTimezone = event.value;
    if (this.selectedDate) {
      this.selectedDateWithTimeZone = this.formatDateWithTimezone(this.selectedDate);
      this.dateSelected.emit({
        date: this.selectedDateWithTimeZone,
        timezone: this.selectedTimezone,
        formattedDate: this.selectedDateWithTimeZone
      });
    }
  }
  getTimezonesByOffset(offsetInMinutes) {
    const offsetInHours = offsetInMinutes / 60;
    return moment.tz.names().filter((tz) => {
      return moment.tz(tz).utcOffset() === offsetInMinutes;
    });
  }
  extractTimezoneWithRegex(dateString: string): string | undefined {
    const match = dateString.match(/([+-]\d{2}:\d{2}|Z)$/);
    return match ? match[1] : undefined;
  }
  setTimeZoneValue()
  { 
    if (this.defaultDate) {
      if (this.dateFormatter.test(this.defaultDate.toString())) {
        this.selectedDate=this.extractDate(this.defaultDate);
        this.selectedTimezone=this.extractTimezoneWithRegex(this.defaultDate.toString());
        this.selectedDateWithTimeZone = this.defaultDate.toString();
      }
      else
      {
        this.selectedDate = new Date(this.defaultDate.toString());
        this.selectedTimezone=this.selectedTimezone || moment().format('Z');
        this.selectedDateWithTimeZone = this.formatDateWithTimezone(this.selectedDate);
    
      }
    }
  }
  extractDate(dateString)
  {
    const splittedData = dateString.split(" ");
    const date = splittedData[0];                      
    const time = splittedData[1] + " " + splittedData[2];  
    return new Date(date+" "+time);
  }
}